module.exports = __webpack_public_path__ + "img/finalizo.f08f96fc.png";